import type { Ref } from 'vue';
import { computed, watch } from 'vue';
import { PriceChangeStatus } from '@/interface/enum';
import { useAutoResetState } from '@/libraries/composables/useAutoResetState';

const ODDS_CHANGE_DISPLAY_DURATION = 3000;

export function useOddsChangeIndicator(
    oddsChangeStatus: Ref<PriceChangeStatus>,
    price: Ref<number | string>,
) {
    const [status, setStatus] = useAutoResetState(PriceChangeStatus.Remain, ODDS_CHANGE_DISPLAY_DURATION);

    watch([oddsChangeStatus, price], () => {
        if (oddsChangeStatus.value !== PriceChangeStatus.Remain) {
            setStatus(oddsChangeStatus.value);
        }
    }, { immediate: true });

    const oddsChangeClass = computed(() => getOddsChangeClass(status.value));

    return { oddsChangeClass };
}

function getOddsChangeClass(status: PriceChangeStatus): string {
    switch (status) {
        case PriceChangeStatus.Rise:
            return 'odd_rise';
        case PriceChangeStatus.Drop:
            return 'odd_drop';
        case PriceChangeStatus.Remain:
        default:
            return '';
    }
}
